import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IButton } from '@kinet-open-network/client/shared/ui';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';

export interface ButtonWrapperProps extends FormlyFieldProps {
  button?: IButton<(model: any, field: FormlyFieldConfig) => void>;
}

@Component({
  selector: 'kon-field-button-wrapper',
  standalone: true,
  imports: [CommonModule, ButtonModule, RouterModule],
  template: `<div class="flex flex-row items-stretch button-wrapper">
    <ng-container #fieldComponent></ng-container>
    <button
      pButton
      type="button"
      [label]="props.button?.label ?? ''"
      [routerLink]="props.button?.routerLink"
      [queryParams]="props.button?.queryParams"
      (click)="props.button?.command?.(this.model, this.field)"
      [icon]="props.button?.icon ?? ''"
      [text]="props.button?.text"
      [outlined]="props.button?.outlined"
      [rounded]="props.button?.rounded"
      [severity]="props.button?.severity"
      [disabled]="props.disabled"
      [size]="props.button?.size"
      [loading]="props.button?.loading ?? false"
    ></button>
  </div> `,
  styleUrl: './field-button-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldButtonWrapperComponent extends FieldWrapper<
  FormlyFieldConfig<ButtonWrapperProps>
> {}
